import { render, staticRenderFns } from "./Premises.vue?vue&type=template&id=06f06fcd&scoped=true&"
import script from "./Premises.vue?vue&type=script&lang=js&"
export * from "./Premises.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f06fcd",
  null
  
)

export default component.exports